import React, { useState, useEffect } from "react";
import {
  ALL_PAID_EICR,
  ALL_PAID_FA,
  ALL_PAID_GENERAL,
  INVOICE_EICR,
  INVOICE_FA,
  INVOICE_GENERAL,
  OVERDUE,
  EICR_QUOTE,
  VISIT_CONFIRMATION,
  setEmailTemplate,
} from "../helperFunctions/templateHelpers";
import { useJobDescriptions } from "../customHooks/useJobDescriptions";
import { timesheetsRef } from "../firebase";
import { calcJobsTotalCost, calcVat } from "../helperFunctions/calculationFunctions";
import { removeCardFees } from "../helperFunctions/pdfFunctions";

function CopyContainer(props) {
  let { primaryFormData, dbRef, vat } = props;

  const jobDescriptions = useJobDescriptions(primaryFormData?.uid, dbRef);
  const [copying, setCopying] = useState(false);
  const [showCopyMessage, setShowCopyMessage] = useState(false);

  useEffect(() => {
    // Only show the copied notification for 1 second
    const timer = setTimeout(() => {
      setShowCopyMessage(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [copying]);

  async function copyToClipboard(copyType) {
    let jdsWithoutCardFees = removeCardFees(jobDescriptions);
    let amount = calcJobsTotalCost(jdsWithoutCardFees, vat)[4];
    const [vatCost, inc] = calcVat(amount, vat);

    // console.log("vat cost", vatCost);
    // console.log("inc", inc);

    let data = await setEmailTemplate(copyType, primaryFormData, inc);

    navigator.clipboard.write(data).then(
      function () {
        /* success */

        setCopying((prevState) => !prevState);
        setShowCopyMessage(true);
      },
      function () {
        /* failure */
      },
    );
  }

  return (
    <div className="copyButtons">
      {showCopyMessage && <p className="copyToClipMessage">copied to clipboard</p>}
      {/* <button
              className="visitConfirmationCopy"
              onClick={() => copyToClipboard("CUSTOMER_ADDRESS")}
              disabled={showCopyMessage}
            >
              Address
            </button> */}

      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(VISIT_CONFIRMATION)}
        disabled={showCopyMessage}
      >
        Visit Confirm
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(INVOICE_EICR)}
        disabled={showCopyMessage}
      >
        Invoice (EICR)
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(ALL_PAID_EICR)}
        disabled={showCopyMessage}
      >
        All Paid (EICR)
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(ALL_PAID_FA)}
        disabled={showCopyMessage}
      >
        All Paid (Fire)
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(INVOICE_FA)}
        disabled={showCopyMessage}
      >
        Invoice (Fire)
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(OVERDUE)}
        disabled={showCopyMessage}
      >
        Overdue
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(EICR_QUOTE)}
        disabled={showCopyMessage}
      >
        Remedials (EICR)
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(INVOICE_GENERAL)}
        disabled={showCopyMessage}
      >
        Invoice
      </button>
      <button
        className="visitConfirmationCopy"
        onClick={() => copyToClipboard(ALL_PAID_GENERAL)}
        disabled={showCopyMessage}
      >
        All Paid
      </button>
    </div>
  );
}

export default CopyContainer;
